import { v1 } from 'uuid';
import formValidations from './formValidations';

const SubmitField  = (type, ref='') => {
    return (val) => {
        return formValidations[`${type}`](val, ref);
    };
};

export default SubmitField;